/**
 * Pulsanti azione merge/validazione — allineati a SmallTable, MatchTable e MergePage.
 * @param {import('@mui/material').Theme} theme
 */
export function mergePrimaryButtonSx(theme) {
  return {
    background: theme.palette.newColors?.pinkGradient,
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 13,
    textTransform: 'none',
    px: 2.5,
    py: 0.75,
    minHeight: 40,
    borderRadius: '10px',
    boxShadow: 'none',
    '&:hover': {
      background: theme.palette.newColors?.pinkGradient,
      opacity: 0.92,
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      color: 'rgba(255,255,255,0.65)',
      background: theme.palette.action.disabledBackground,
    },
  }
}

/** Navigazione indietro / azioni secondarie */
export function mergeSecondaryButtonSx(theme) {
  return {
    background: theme.palette.newColors?.cyanGradient,
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 13,
    textTransform: 'none',
    px: 2.5,
    py: 0.75,
    minHeight: 40,
    borderRadius: '10px',
    boxShadow: 'none',
    '&:hover': {
      background: theme.palette.newColors?.cyanGradient,
      opacity: 0.92,
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      color: 'rgba(255,255,255,0.65)',
      background: theme.palette.action.disabledBackground,
    },
  }
}

/** Link testuale (Overview, annulla) */
export function mergeGhostButtonSx(theme) {
  return {
    color: theme.palette.newColors?.gray || theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'none',
    px: 2,
    py: 0.75,
    minHeight: 40,
    borderRadius: '10px',
    '&:hover': {
      bgcolor:
        theme.palette.mode === 'light'
          ? 'rgba(66, 91, 97, 0.08)'
          : 'rgba(255,255,255,0.08)',
      color: theme.palette.newColors?.gray || theme.palette.text.primary,
    },
  }
}
